import React from "react";
import { Card, CardBody, FormGroup, InputGroup } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import DefaultMultipleSelect from "../DefaultMultipleSelect/DefaultMultipleSelect";
import { getCurrentDay, getSelectedDaysAgo } from "../../helpers/utils";
import CustomMultipleDateRange from "../CustomMultipleDateRange/CustomMultipleDateRange";
import ReactSelect from "react-select";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Slider from "rc-slider";

const DynamicFormFilterBetween = props => {
  const [date, setDate] = React.useState({});
  const [sliderData, setSliderData] = React.useState([
    props.filtered_params?.min || 20000,
    props.filtered_params?.max || 79000,
  ]);
  const [filteredNums, setFilteredNums] = React.useState({
    min: {
      val: props.filtered_params?.min || "",
    },
    max: {
      val: props.filtered_params?.max || "",
    },
  });

  React.useEffect(() => {
    setDate(
      `${
        props.selectedDate !== null
          ? props.selectedDate.start_date
          : getSelectedDaysAgo(31)
      } to ${
        props.selectedDate !== null
          ? props.selectedDate.end_date
          : getCurrentDay()
      }`
    );
  }, []);

  React.useEffect(() => {
    const timeOutId = setTimeout(() => {
      props.onFiltersChange(
        { min: filteredNums?.min.val, max: filteredNums?.max.val },
        filteredNums?.min?.key || "sum"
      );
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [filteredNums]);

  const changeSliderData = (arr, key) => {
    setSliderData(arr);
    setFilteredNums({
      ...filteredNums,
      min: {
        val: arr[0],
        key: key,
      },
      max: {
        val: arr[1],
        key: key,
      },
    });
  };

  const handleSelect = (data, filterType) => {
    let filteredData = {};
    filteredData[filterType] = [];

    if (Array.isArray(data)) {
      data.map(i => filteredData[filterType].push(i.value));
    } else {
      filteredData[filterType].push(data.value);
    }

    props.onFiltersChange({ ...filteredData }, filterType);
  };

  const onFiltersChange = (date, key) => {
    if (date) {
      setDate(date);
      const data = {
        start_date: date.start_date,
        end_date: date.end_date || getCurrentDay(),
      };
      if (date.end_date !== undefined) {
        props.onFiltersChange(data, key);
      }
    } else {
      props.onFiltersChange({}, key);
    }
  };

  const handleSetDefaultDate = (params, date_type) => {
    let date = "";
    if (
      params[date_type[0]] !== undefined &&
      params[date_type[1]] !== undefined
    ) {
      let current = {
        start_date: new Date(params[date_type[0]]),
        end_date: new Date(params[date_type[1]]),
      };
      const selectedDate = {
        start_date:
          new Date(current.start_date.setHours(12)).toJSON().split("T")[0] ||
          "",
        end_date:
          new Date(current.end_date.setHours(12)).toJSON().split("T")[0] || "",
      };
      date = selectedDate["start_date"] + " to " + selectedDate["end_date"];
      return {
        start_date: selectedDate["start_date"],
        end_date: selectedDate["end_date"],
      };
    }
  };

  const onlyMonthFilterChange = (date, key) => {
    let data = {};

    if (date) {
      setDate(date);
      let currentDate = new Date(date.value);
      let lastDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        currentDate.getDate(),
        0
      );

      data = {
        start_date: new Date(currentDate).toJSON().split("T")[0] || "",
        end_date: new Date(lastDay).toJSON().split("T")[0] || "",
      };
    }

    props.onFiltersChange(data, key);
  };

  // const changeInputs = (i, val, key) => {
  //   let currentData = filteredNums;
  //   currentData[i] = Number(val) || 0;
  //   setFilteredNums([currentData[0], currentData[1]]);

  //   props.onFiltersChange({ min: currentData[0], max: currentData[1] }, key);
  // };

  const defaultInputs = {};

  return (
    <>
      <StyledRow>
        <div
          style={{
            background: "#f8f8fb",
            display: props?.disableFilterBy ? "none" : "",
          }}
        >
          <span style={{ fontWeight: "600", fontSize: "15px" }}>
            Filter by:
          </span>
        </div>
        <div className="col-12">
          <StyledCard cardcolor={props.cardcolor}>
            <CardBody
              style={{
                padding: "1rem 0",
                ...props.style,
              }}
            >
              <div className="row gy-2 gx-3 align-items-center">
                <FilterContainer className={`${props.ContainerClassName || ''}`}>
                  {props.dateFilters?.map((i, idx) => (
                    <div key={i.key + "_" + idx}>
                      {i?.onlyMonth ? (
                        <AvForm>
                          <PickerStyled key={i.key + "_" + idx}>
                            {i.isTitle !== false && <p>{i.plug}:</p>}
                            <CustomMultipleDateRange
                              value={
                                props.filtered_params[`${i.filterType[0]}`]
                              }
                              className="form-control d-block"
                              placeholder={`Select ${i.plug || "date"}...`}
                              name={`-${idx}-between`}
                              defaultValue={getCurrentDay}
                              datePickerType={"calendar-with-static"}
                              customStyle={
                                {
                                  // top: "55px",
                                }
                              }
                              onChange={date =>
                                onlyMonthFilterChange(date, i.key)
                              }
                              monthTextFormat
                              clearDate
                            />
                          </PickerStyled>
                        </AvForm>
                      ) : !i?.numRange ? (
                        <AvForm>
                          <PickerStyled key={i.key} customwidth={i?.customWidth || ''}>
                            {i.isTitle !== false && <p>{i.plug}:</p>}
                            <CustomMultipleDateRange
                              defaultValue={getCurrentDay}
                              className="form-control d-block"
                              placeholder={`Select ${i.plug}...`}
                              name={`-${idx}-between`}
                              datePickerType="round"
                              value={
                                handleSetDefaultDate(
                                  props.filtered_params,
                                  i.filterType
                                ) || i?.value
                              }
                              onChange={date => onFiltersChange(date, i.key)}
                              clearDate={i?.clearDate ? true : false}
                            />
                          </PickerStyled>
                        </AvForm>
                      ) : (
                        <AvForm
                          style={{ marginBottom: "14px" }}
                          key={i.key + "_" + idx}
                          model={defaultInputs}
                        >
                          {i.isTitle !== false && (
                            <p
                              style={{
                                position: "relative",
                                margin: " 0 0 0 0",
                                top: "-8px",
                              }}
                            >
                              {i.plug}:
                            </p>
                          )}
                          <StyledNums>
                            <div
                              style={{ minWidth: 190, position: "absolute" }}
                            >
                              <Slider
                                range
                                min={0}
                                max={100000}
                                step={1}
                                allowCross={false}
                                value={sliderData}
                                onChange={e => changeSliderData(e, i.key)}
                                railStyle={{ backgroundColor: "#ced4da" }}
                                trackStyle={{ backgroundColor: "#34c38f" }}
                                handleStyle={{
                                  borderColor: "#34c38f",
                                  backgroundColor: "#ced4da",
                                }}
                              />
                            </div>
                            <div className="n--min">
                              <FormGroup>
                                <AvField
                                  value={filteredNums?.min?.val}
                                  name="min_value"
                                  type="number"
                                  errorMessage="This value is required"
                                  onChange={e => {
                                    setFilteredNums({
                                      ...filteredNums,
                                      min: {
                                        val: e.target.value,
                                        key: i.key,
                                      },
                                    });
                                    setSliderData([
                                      e.target.value,
                                      filteredNums?.max.val,
                                    ]);
                                  }}
                                  placeholder="From..."
                                />
                              </FormGroup>
                            </div>
                            <Tire>-</Tire>
                            <div className="n--max">
                              <FormGroup>
                                <AvField
                                  value={filteredNums?.max?.val}
                                  name="max_value"
                                  type="number"
                                  errorMessage="This value is required"
                                  onChange={e => {
                                    setFilteredNums({
                                      ...filteredNums,
                                      max: {
                                        val: e.target.value,
                                        key: i.key,
                                      },
                                    });
                                    setSliderData([
                                      filteredNums?.min.val,
                                      e.target.value,
                                    ]);
                                  }}
                                  placeholder="To..."
                                />
                              </FormGroup>
                            </div>
                          </StyledNums>
                        </AvForm>
                      )}
                    </div>
                  ))}
                  {props.filtersFields &&
                    props.filtersFields.map((i, key) => (
                      <FilteredStyled
                        className={`col-sm-auto float-end gy-2 gx-3`}
                        style={{
                          ...i.style,
                        }}
                        key={key + "filter-select"}
                      >
                        {i.isTitle !== false && <p>{i.title}:</p>}
                        {i?.singleSelect ? (
                          <CustomSelect
                            defaultValue={
                              props.filtered_params?.[`${i.filterType}`]
                                ? {
                                    value:
                                      props.filtered_params?.[
                                        `${i.filterType}`
                                      ],
                                    label:
                                      props.filtered_params?.[
                                        `${i.filterType}`
                                      ],
                                  }
                                : {
                                    value: "ALL",
                                    label: "ALL",
                                  }
                            }
                            // value={this.state.selectedFilter}
                            // onChange={this.handleSelectStatus}
                            onChange={select =>
                              handleSelect(select, i.filterType || null)
                            }
                            options={
                              i.filterData?.length > 0
                                ? i.filterData.map(item => ({
                                    value: item.id || item,
                                    label: item.name || item,
                                  }))
                                : []
                            }
                            classNamePrefix="select2-selection"
                            styles={{
                              dropdownIndicator: (base, state) => ({
                                ...base,
                                transition: "all .2s ease",
                                transform: state.selectProps.menuIsOpen
                                  ? "rotate(180deg)"
                                  : null,
                              }),
                            }}
                          />
                        ) : (
                          <DefaultMultipleSelect
                            options={
                              i.filterData?.length > 0
                                ? i.filterData.map(item => ({
                                    key: item.id || item,
                                    text: item.name || item,
                                    checked: item.checked || false,
                                  }))
                                : []
                            }
                            customWidth={{
                              width: i?.customWidth || "190px",
                            }}
                            hasSelectAll={i?.hasSelectAll}
                            filtered_by={props.filtered_by[key]}
                            filtered_params={props.filtered_params}
                            isDisabled={i.isDisabled}
                            onChange={select =>
                              handleSelect(select, i.filterType || null)
                            }
                            plug={i.plug}
                            search
                            shouldUpdateOptions={false}
                          />
                        )}
                      </FilteredStyled>
                    ))}
                </FilterContainer>
              </div>
            </CardBody>
          </StyledCard>
        </div>
      </StyledRow>
    </>
  );
};

const StyledNums = styled.div`
  display: flex;
  width: 190px;

  .n--min {
    input {
      height: 20px;
      position: relative;
      top: 16px;
      font-size: 0.7rem;
    }
  }

  .n--max {
    input {
      height: 20px;
      position: relative;
      top: 16px;
      font-size: 0.7rem;
    }
  }
`;

const Tire = styled.span`
  position: relative;
  width: 10px;
  vertical-align: middle;
  right: 0;
  top: 17px;
`;

const CustomSelect = styled(ReactSelect)`
  min-width: 190px;

  .select2-selection__indicators {
    span {
      display: none !important;
    }
  }

  .select2-selection__control {
    &.select2-selection__control--is-focused {
      box-shadow: none !important;
      border-color: rgb(189, 195, 200) !important;

      &.select2-selection__control--menu-is-open {
        box-shadow: none !important;
        border-color: rgb(189, 195, 200) !important;
      }
    }
  }
`;

const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  vertical-align: center;
  padding-right: 0;
`;

const FilteredStyled = styled.div`
  margin-right: 8px;
  margin-bottom: 5px;
  p {
    margin-bottom: 6px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: ${props => props.cardcolor && `${props.cardcolor}`};
  border-radius: 0.1px;
`;

const PickerStyled = styled(InputGroup)`
  max-width: ${({ customwidth }) => `${customwidth || '190px'}`};
  margin-right: 8px;
  margin-bottom: 5px;
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    font-size: 12px;
    background: #fff !important;
  }
`;

DynamicFormFilterBetween.defaultProps = {
  disableFilterBy: false,
  cardcolor: "#f8f8fb",
};

DynamicFormFilterBetween.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  data: PropTypes.any,
  filtersFields: PropTypes.any,
  selectedDate: PropTypes.any,
  dateFilters: PropTypes.array,
  onFilterSelect: PropTypes.func,
  style: PropTypes.object,
  filterTitle: PropTypes.any,
  filtered_params: PropTypes.any,
  filtered_by: PropTypes.array,
  disableFilterBy: PropTypes.bool,
  cardcolor: PropTypes.string,
  ContainerClassName: PropTypes.string
};

export default DynamicFormFilterBetween;
